import React, { FormEvent, useState } from 'react'
import TextField from '@material-ui/core/TextField'
import { useMutation } from '@apollo/client'
import Button from '@material-ui/core/Button'
import { MC_MATERIAL_CATALOGUE } from 'graphql/mutations'
import Loading from 'components/Global/Loading'

import styles from '../materials.module.scss'

interface Props {
  close: () => void
}

const CreateCatalogue = ({ close: close }: Props) => {
  const [call] = useMutation(MC_MATERIAL_CATALOGUE)
  const [loading, setLoading] = React.useState<boolean>(false)

  const [ctlogName, setCtlogName] = useState<string>('')
  const [ctlogCode, setCtlogCode] = useState<string>('')
  const [ctlLogo, setCtlLogo] = useState<File | null>()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true)
    call({
      variables: {
        name: ctlogName,
        codeStore: ctlogCode,
        logo: ctlLogo,
      },
    })
      .then(res => {
        close()
      })
      .catch(err => console.error(err))
    return false
  }
  return loading ? (
    <Loading />
  ) : (
    <form className={styles.createRoot} onSubmit={e => handleSubmit(e)}>
      <TextField
        autoFocus
        value={ctlogName || ''}
        label="Catalogue Name"
        onChange={e => setCtlogName(e.target.value)}
        fullWidth
        className={styles.marginP5}
      />
      <TextField
        value={ctlogCode || ''}
        label="Catalogue Code"
        onChange={e => setCtlogCode(e.target.value)}
        inputProps={{ maxLength: 2 }}
        fullWidth
        className={styles.marginP5}
      />

      <Button
        id="environment"
        variant="contained"
        component="label"
        fullWidth
        className={styles.marginP5}
      >
        {ctlLogo ? `${ctlLogo.name}` : "select logo for catalogue 'svg'"}
        <input
          type="file"
          accept=".svg"
          hidden
          onChange={e => {
            if (e.target.files) {
              setCtlLogo(e.target.files[0])
            }
          }}
        />
      </Button>
      <Button
        variant="contained"
        color="secondary"
        className={styles.margin}
        type="submit"
      >
        Create
      </Button>
    </form>
  )
}
export default CreateCatalogue
